<template>
  <div class="product-list">
    <div
      class="product-item"
      v-for="product in $t('productlistsenven.items')"
      :key="product.id"
      @click="showModal(product)"
    >
      <img :src="product.image" :alt="product.title" />
      <div class="product-title">{{ product.title }}</div>
    </div>

    <!-- 弹出框 -->
    <div v-if="isModalVisible" class="modal">
      <div class="modal-content">
        <span  class="productsdectitle" >{{$t('productsdectitle')}}</span>
        <span class="close" @click="hideModal">&times;</span>
        <div class="modal-body">
          <div class="selectedProduct-box">
            <img
              :src="selectedProduct.image"
              class="selectedProduct-img"
              :alt="selectedProduct.title"
            />
          </div>
          <div class="product-title-dec">{{ selectedProduct.title }}</div>
          <div class="model">
           <div  class="model-li" > <span  class="title-one-dec">{{$t('chip')}}</span>: <span>{{ selectedProduct.chip }}</span></div>
           <div  class="model-li" > <span class="title-one-dec">{{$t('frequency')}}</span>: <span>{{ selectedProduct.frequency }}</span></div>
           <div  class="model-li"> <span class="title-one-dec">{{$t('material')}}</span>: <span>{{ selectedProduct.material }}</span></div>
           <div  class="model-li" > <span class="title-one-dec">{{$t('weight')}}</span>: <span>{{ selectedProduct.weight }}</span></div>
           <div  class="model-li" > <span class="title-one-dec">{{$t('size')}}</span>: <span>{{ selectedProduct.size }}</span></div>
           <div  class="model-li" > <span class="title-one-dec" >{{$t('Operatingtemperature')}}</span>: <span>{{ selectedProduct.Operatingtemperature }}</span></div>
            <div  class="model-li" > <span class="title-one-dec" >{{$t('readingDistance')}}</span>: <span>{{ selectedProduct.readingDistance }}</span></div>

            <div  class="model-li" > <span class="title-one-dec" >{{$t('advone1')}}</span>: <span>{{$t('advone18')}}</span></div>
              <div  class="model-li" > <span class="title-one-dec" >{{$t('advone3')}}</span>: <span>{{$t('advone19')}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 
  data() {
    return {
      isModalVisible: false,
      selectedProduct: null,
    };
  },
  methods: {
    showModal(product) {
      this.selectedProduct = product;
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
  },
};
</script>

<style scoped>
.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.product-item {
  width: 30%;
  margin: 10px 1%;
  text-align: center;
  background: #fff;
  border: 1px solid #ddd;
  padding-bottom: 20px;
  cursor: pointer;
}
.product-item img {
  width: 100%;
  height: auto;
}
.product-title {
  margin-top: 10px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 70%;
  position: relative;
  border-radius: 5px;
 
}

.selectedProduct-box {
  width: 100%;
  text-align: center;
}
.selectedProduct-img {
  width: 50%;
  margin-bottom: 20px;
}
.product-title-dec{
  background: #d1261e;
  color: #fff;
  padding: 10px 20px;
  box-sizing: border-box;
  text-align: center;
}

.close {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size:40px;
  cursor: pointer;
}
.model{
  border: 1px solid #ddd;
    padding: 10px 20px;
  box-sizing: border-box;
}
.model-li{
  padding: 10px;
   box-sizing: border-box;
   border-bottom: 1px solid #ddd;
}

.modal-body {
  margin-top: 20px;
   height: 700px;
  overflow-y: auto;
}

@media (max-width: 1200px) {
  .modal-content {
    width: 80%;
  }
  .selectedProduct-img {
    width: 100%;
  }
  .product-item {
    width: 47%;
    margin: 10px 1%;
  }
  .modal-body {
   height: 500px;
}
}
</style>